import baseAPI from '@/api/base';
import {
  EditShiureiTorahTemplate,
  GetShiureiTorahTemplate,
  RegisterShiureiTorahTemplate,
} from '@/dtos/shiurei_torah_template.dto';
import {
  DELETE_SHIUREI_TORAH_TEMPLATE_URL,
  EDIT_SHIUREI_TORAH_TEMPLATE_URL,
  GET_SHIUREI_TORAH_TEMPLATE_URL,
  REGISTER_SHIUREI_TORAH_TEMPLATE_URL,
  TOGGLE_SHIUREI_TORAH_TEMPLATE_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class ShiureiTorahTemplate {
  static getShiureiTorahTemplates = async (
    getShiureiTorahTemplate: GetShiureiTorahTemplate
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_SHIUREI_TORAH_TEMPLATE_URL, {
      params: getShiureiTorahTemplate,
    });
    console.log('response', response);
    return response;
  };

  static registerShiureiTorahTemplate = async (
    registerShiureiTorahTemplate: RegisterShiureiTorahTemplate
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_SHIUREI_TORAH_TEMPLATE_URL,
      {
        ...registerShiureiTorahTemplate,
      }
    );
    console.log('response', response);
    return response;
  };

  static editShiureiTorahTemplate = async (
    editShiureiTorahTemplate: EditShiureiTorahTemplate
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_SHIUREI_TORAH_TEMPLATE_URL,
      {
        ...editShiureiTorahTemplate,
      }
    );
    return response;
  };

  static toggleShiureiTorahTemplateIsActive = async (
    editShiureiTorahTemplate: EditShiureiTorahTemplate
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_SHIUREI_TORAH_TEMPLATE_IS_ACTIVE_URL,
      {
        ...editShiureiTorahTemplate,
      }
    );
    return response;
  };

  static deleteShiureiTorahTemplate = async (
    id: string
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_SHIUREI_TORAH_TEMPLATE_URL}/${id}`
    );
    return response;
  };
}

export default ShiureiTorahTemplate;
